import { render, staticRenderFns } from "./shop-address-page.vue?vue&type=template&id=3fc5c4fe&scoped=true"
import script from "./shop-address-page.vue?vue&type=script&lang=js"
export * from "./shop-address-page.vue?vue&type=script&lang=js"
import style0 from "./shop-address-page.vue?vue&type=style&index=0&id=3fc5c4fe&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fc5c4fe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/快电商/preview-qcommerce-h5/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3fc5c4fe')) {
      api.createRecord('3fc5c4fe', component.options)
    } else {
      api.reload('3fc5c4fe', component.options)
    }
    module.hot.accept("./shop-address-page.vue?vue&type=template&id=3fc5c4fe&scoped=true", function () {
      api.rerender('3fc5c4fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/h5/shop-address-page.vue"
export default component.exports